var map = {
	"./01-EMDR.mp3": 8468,
	"./PRO-05-EMDR.mp3": 7118,
	"./PRO-12-EMDR.mp3": 2818,
	"./PRO-14-EMDR.mp3": 5008,
	"./PRO-18-EMDR.mp3": 6652
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6981;